<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">查看/编辑个人档案</h2>
      <!-- <a href="javascript:;" @click="$router.back()" class="back-btn">返回列表</a> -->
    </div>
    <div class="form-content">
      <!-- <el-col :span="22"> -->
      <el-form ref="form" :model="form" label-width="98px" class="form">

        <user-info ref="create" :formByFather="form"></user-info>

        <div class="tip" style="margin:20px 0 0 20px">
          * 相关附件
        </div>
        <div class="clear">
          <el-form-item label="上传附件">
            <attachments style="margin-left:-15px;" :projectId="form.projectId" :contractId="form.contractId"
              ref="attachments" :arr="attachmentArr" :type='990'></attachments>
          </el-form-item>
        </div>

        <el-form-item label="">
          <div class="form-btn-room">
            <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">{{formBtnText}}
            </el-button>
            <!-- <el-button @click="$router.back()" v-if="form.archivesId" type="info" plain>取消修改</el-button> -->
          </div>
        </el-form-item>

      </el-form>
      <!-- </el-col> -->
    </div>
  </div>
</template>


<script>
  import {
    mapState
  } from "vuex";

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'
  import UserInfo from '@/page/form/personnel/userInfo'
  export default {
    components: {
      ApprovalItem,
      UserInfo,
      Attachments,
    },
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // userInfo: {},
        form: {
          "archivesId": "",
          "birthAddress": "",
          "birthPlace": "",
          "certificate": "",
          "email": "",
          "families": [{
            "birthday": "",
            "callName": "",
            "job": "",
            "name": "",
            "phone": "",
            "zzmm": ""
          }, ],
          "fullEdu": "",
          "fullSchool": "",
          "homeAddress": "",
          "idCard": "",
          "img": "",
          "jobEdu": "",
          "jobSchool": "",
          "joinPartyTime": "",
          "joinTime": "",
          "linkPhone": "",
          "linkman": "",
          "marriage": "",
          "nation": "",
          "phone": "",
          "position": "",
          "positions": [{
            "endTime": "",
            "startTime": "",
            "workPlace": ""
          }, {
            "endTime": "",
            "startTime": "",
            "workPlace": ""
          }, {
            "endTime": "",
            "startTime": "",
            "workPlace": ""
          }, {
            "endTime": "",
            "startTime": "",
            "workPlace": ""
          }],
          "resumes": [{
            "endTime": "",
            "jcRecord": "",
            "startTime": "",
            "workPlace": ""
          }],
          "reward": "",
          "tbTime": "",
          "tel": "",
          "zzTime": "",
          "zzmm": ""
        },

        // 附件
        attachmentArr: [],

        formLoading: false,

        applyInfo: '',
        formBtnText: '确认提交档案'
      }
    },
    created() {
      this.getUserData()
    },
    mounted() {},
    methods: {
      getUserData() {
        this.form.archivesId = this.$route.params.archivesId
        if (this.form.archivesId) {
          this.formLoading = true
          this.getUserInfo()
          this.formBtnText = "确认修改档案"
        }
      },
      // 获取已有个人信息
      getUserInfo() {
        ajax.get('/human/record/detail/' + this.form.archivesId, '', (res) => {
          this.formLoading = false
          // this.userInfo = res.vo.userVO
          this.form = res.vo
          if (!this.form.families || this.form.families.length < 1) {
            this.form.families = [{
              "birthday": "",
              "callName": "",
              "job": "",
              "name": "",
              "phone": "",
              "zzmm": ""
            }, ]
          }
          if (!this.form.positions || this.form.positions.length < 4) {
            if (!this.form.positions) {
              this.form.positions = []
            }
            let _length = this.form.positions.length
            for (; _length < 4; _length++) {
              this.form.positions.push({
                "endTime": "",
                "startTime": "",
                "workPlace": ""
              })
            }
          }

          if (!this.form.resumes || this.form.resumes.length < 1) {
            this.form.resumes = [{
              "endTime": "",
              "jcRecord": "",
              "startTime": "",
              "workPlace": ""
            }]
          }
        })
      },
      // 提交项目申请
      createProject() {
        this.form = this.$refs.create.getFromData()
        this.form.json = true
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true

        let _url = '/human/record/add'
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.archivesId) {
            this.$message.success("提交个人档案成功")
          } else {
            this.$message.success("修改个人档案成功")
          }
          this.$router.push("/Personnel/List")
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      "$route"() {
        this.getUserData()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/personnel/create.vue